import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { ClassesPage } from './pages/ClassesPage';
import { MembershipPage } from './pages/MembershipPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { SignupPage } from './pages/SignupPage';
import { LoginPage } from './pages/LoginPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
        <Route path="/classes" element={<ClassesPage data-id="element-15" />} data-id="element-14" />
        <Route path="/membership" element={<MembershipPage data-id="element-17" />} data-id="element-16" />
        <Route path="/about" element={<AboutPage data-id="element-19" />} data-id="element-18" />
        <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
        <Route path="/signup" element={<SignupPage data-id="element-23" />} data-id="element-22" />
        <Route path="/login" element={<LoginPage data-id="element-25" />} data-id="element-24" />
      </Routes>
    </BrowserRouter>;
}